import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../../lib/api";
import { aiEstraiUno, segnaUsato, spiegaErrore } from "../../lib/aiUpload";
import { caricaAllegato } from "./AllegatoBtn";
import { eur } from "../../lib/impresa";
import UploadAIDialog from "../UploadAIDialog";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Receipt, CheckCircle, Trash, ArrowRight } from "@phosphor-icons/react";

/** Modalità cantiere: foto di scontrino / DDT / fattura → letta dall'AI → movimento salvato nel cantiere scelto, in due tap. */
export default function ScontrinoRapido({ cantiere }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [prog, setProg] = useState(null);
  const [ultimi, setUltimi] = useState([]);

  const onFile = async (file) => {
    if (!cantiere) { toast.error("Scegli prima il cantiere"); return; }
    setBusy(true); setProg(null);
    try {
      const data = await aiEstraiUno("impresa/ai/estrai-documento", file, { onProgress: setProg });
      const m = data.movimento;
      const scontrino = !m.numero_documento && (m.imponibile || 0) < 300;
      const body = { ...m, tipo: "uscita", cantiere_id: cantiere.id, categoria: m.categoria === "ddt" ? "ddt" : scontrino ? "altro" : "fattura_ricevuta",
        pagamento_metodo: scontrino ? "contanti" : (m.pagamento_metodo || "banca"), pagato: scontrino, data_pagamento: scontrino ? m.data : "",
        descrizione: m.descrizione || (scontrino ? "Scontrino cantiere" : "Documento cantiere"), note: `Registrato dalla Modalità cantiere · ${file.name}` };
      const { data: creato } = await api.post("/impresa/movimenti", body);
      try { await caricaAllegato(creato.id, file); } catch { segnaUsato(file); }
      const tot = (body.imponibile || 0) * (1 + (body.iva_percentuale || 0) / 100);
      setUltimi((u) => [{ id: creato.id, controparte: body.controparte, tot, categoria: body.categoria, data: body.data }, ...u].slice(0, 5));
      toast.success(`Salvato in ${cantiere.nome}: ${body.controparte || body.descrizione} · ${eur(tot)}`);
      setOpen(false);
    } catch (e) { toast.error(spiegaErrore(e)); } finally { setBusy(false); setProg(null); }
  };
  const annulla = async (u) => { try { await api.delete(`/impresa/movimenti/${u.id}`); setUltimi((l) => l.filter((x) => x.id !== u.id)); toast.success("Registrazione annullata"); } catch { toast.error("Impossibile annullare"); } };

  return (
    <>
      <button type="button" onClick={() => (cantiere ? setOpen(true) : toast.error("Scegli prima il cantiere"))} className="text-left w-full" data-testid="tile-scontrino">
        <Card className={`p-5 h-full hover:shadow-md transition-shadow border-slate-200 ${cantiere ? "" : "opacity-60"}`}>
          <Receipt size={28} className="text-[#0B1F3A]" />
          <div className="font-heading font-bold text-lg mt-4">Scontrino / DDT</div>
          <div className="text-xs text-slate-500 mt-1">Foto → letto dall'AI → salvato nel cantiere con il file allegato</div>
        </Card>
      </button>
      <UploadAIDialog open={open} onOpenChange={setOpen} busy={busy} progresso={prog} onFile={onFile} titolo={`Scontrino / DDT · ${cantiere?.nome || ""}`} />
      {ultimi.length > 0 && (
        <Card className="p-3 space-y-1.5" data-testid="scontrini-registrati">
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Registrati adesso</div>
          {ultimi.map((u) => (
            <div key={u.id} className="flex items-center gap-2 text-sm" data-testid={`scontrino-${u.id}`}>
              <CheckCircle size={15} className="text-emerald-600 shrink-0" />
              <span className="flex-1 truncate">{u.controparte || "—"} <span className="text-xs text-slate-500">· {u.categoria === "ddt" ? "DDT" : u.categoria === "altro" ? "scontrino" : "fattura"}</span></span>
              <span className="font-mono font-semibold">{eur(u.tot)}</span>
              <Button size="sm" variant="ghost" className="h-7 w-7 p-0" title="Annulla registrazione" onClick={() => annulla(u)} data-testid={`scontrino-annulla-${u.id}`}><Trash size={13} className="text-red-600" /></Button>
            </div>
          ))}
          <Link to={`/impresa/movimenti?cantiere=${cantiere?.id || ""}`} className="inline-flex items-center gap-1 text-xs text-[#0B1F3A] underline-offset-2 hover:underline" data-testid="scontrini-vai-movimenti">Vedi tutti i movimenti del cantiere <ArrowRight size={12} /></Link>
        </Card>
      )}
    </>
  );
}
